/**
 * Entity registry KEYS — dependency-free.
 *
 * Kept separate from `registry.ts` (which imports every entity's config and
 * therefore pulls in feature/UI modules) so that server code — e.g. the
 * entity-chat API route — can validate an entity key without dragging the whole
 * registry graph into its bundle.
 */

/** All registered entity keys (snake_case). */
export const ENTITY_REGISTRY_KEYS = [
  "contacts",
  "companies",
  "deals",
  "tickets",
  "time_entries",
  "tasks",
  "communications",
  "recurring_transactions",
  "recurring_charges",
  "contracts",
  "social_media_posts",
  "email_campaigns",
  "employees",
  "admin_users",
  "offerings",
] as const;

export type EntityRegistryKey = (typeof ENTITY_REGISTRY_KEYS)[number];

export function isEntityRegistryKey(entity: unknown): entity is EntityRegistryKey {
  return (
    typeof entity === "string" &&
    (ENTITY_REGISTRY_KEYS as readonly string[]).includes(entity)
  );
}
